import { Checkbox, FormControlLabel, Stack, TextField } from "@mui/material";

interface CheckboxWithTextProps {
  checked: boolean;
  disabled: boolean;
  label: string;
  isTextActive: boolean;
  textLabel: string;
  textValue: string;
  error?: string;
  onCheckChange: (checked: boolean) => void;
  onTextChange: (value: string) => void;
}

const CheckboxWithText = ({
  checked,
  disabled,
  label,
  isTextActive,
  textLabel,
  textValue,
  error,
  onCheckChange,
  onTextChange,
}: CheckboxWithTextProps) => (
  <Stack alignItems="center" direction="row">
    <FormControlLabel
      control={<Checkbox checked={checked} disabled={disabled} onChange={(e) => onCheckChange(e.target.checked)} />}
      label={label}
      sx={[isTextActive && { height: (theme: any) => `calc(${theme.spacing(7)} + 2px)` }]}
    />
    <TextField
      disabled={disabled || !isTextActive}
      error={!!error && isTextActive && !disabled}
      helperText={isTextActive && !disabled && error ? error : null}
      label={textLabel}
      onChange={(e) => onTextChange(e.target.value)}
      required={isTextActive}
      size="small"
      value={textValue}
    />
  </Stack>
);

export default CheckboxWithText;
